import { Injectable } from '@angular/core';
import axios, { AxiosResponse } from 'axios';
import { Config } from 'merchandising-sdk';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor() { }

    async SaveDevice(onesignal_id: string, device_type: 'android' | 'ios' | 'web') {
        try {
            const options: any = {
                withCredentials: true
            };

            const url = `${Config.ONLINE_API_URL}/api/devices/register`
            const response: AxiosResponse = await axios.post(url, {
                onesignal_player_id: onesignal_id,
                device_type
            }, options);

            return response.data;
        } catch (e: any) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
}
